import { axiosSwagger } from "@/axios";


export const state = {
  advancedSearch: {
    loading: false,
    data: [],
    total: 0,
  },
  history: {
    loading: false,
    data: []
  }
}


export const getters = {
}


export const mutations = {
  // ADVANCED SEARCH
  loading: (state, loading) => {
    state.advancedSearch.loading = loading;
  },
  setData: (state, data) => {
    state.advancedSearch.data = data;
  },
  setCustomData: (state, data) => {
    state.advancedSearch.data = modifyData( data );
  },
  setTotal: (state, total) => {
    state.advancedSearch.total = total;
  },
  setHistorySave: (state, data) => {
    state.history.data = data;
  },
  setHistoryData: (state, data) => {
    // check if naay duplicate value sa search
    const index = state.history.data.findIndex((item) => item.search === data.search);

    if(index !== -1){
      // if naay duplicate, e delete ang object
      state.history.data.splice(index, 1);
    }
    state.history.data.unshift(data);

    // check if more than {{ length }} na ang data if true e delete ang sobra
    if(state.history.data.length > 5){
      state.history.data.splice(5);
    }

    saveState('SEARCH_HISTORY', state.history.data);
  },
  removeHistoryData: (state, id) => {
    state.history.data = state.history.data.filter((el) => el.id !== id);

    saveState('SEARCH_HISTORY', state.history.data);
  },
  removeAllHistoryData: (state) => {
    state.history.data = [];

    saveState('SEARCH_HISTORY', '[]');
  }
}


export const actions = {
  // READ ADVANCED SEARCH
  async readAdvanceSearch({ commit }, data) {
    commit("loading", true);

    const userData = localStorage.getItem("USER") !== null && localStorage.getItem("USER") !== '' ? JSON.parse(localStorage.getItem("USER")) : null;

    return await axiosSwagger
      .get(`/api/Core/Search${data.type ? `/${data.type}` : '/any'}/${userData?.deliveryUnit?.id}?search=${data.text}`)
      .then((response) => {
        // custom id for file tags result
        let customResponseData = response.data.map((obj, index) => {
          if(obj.type.toLowerCase() === 'tag'){
            obj.id = parseInt(index.toString() + obj.id);
          }
          return obj;
        });

        commit("setData", customResponseData ?? []);
        commit("setTotal", response.data.length ?? 0);
        commit("loading", false);

        return response;
      })
      .catch(() => {
        commit("loading", false);
      });
  },
  async readAdvanceSearchV2({ commit }, data) {
    commit("loading", true);

    const userData = localStorage.getItem("USER") !== null && localStorage.getItem("USER") !== '' ? JSON.parse(localStorage.getItem("USER")) : null;
    const customData = {
      ...data,
      type: data.type === 'any' ? '' : data.type,
    }

    return await axiosSwagger
      .post(`/api/Core/Search/${userData?.deliveryUnit?.id}`, customData)
      .then((response) => {
        // custom id for file tags result
        let customResponseData = response.data.map((obj, index) => {
          if(obj.type.toLowerCase() === 'tag'){
            obj.id = parseInt(index.toString() + obj.id);
          }
          return obj;
        });

        commit("setData", customResponseData ?? []);
        commit("setTotal", response.data.length ?? 0);
        commit("loading", false);

        return response;
      })
      .catch(() => {
        commit("loading", false);
      });
  },
  // READ CATEGORY FILES BY DELIVERY UNIT ID
  async readFileByCategoryId({ commit }, id) {
    commit("loading", true);

    const userData = localStorage.getItem("USER") !== null && localStorage.getItem("USER") !== '' ? JSON.parse(localStorage.getItem("USER")) : null;

    return await axiosSwagger
    .get(`/api/FileManager/Category/${id}/${userData?.deliveryUnit?.id}`)
    .then((response) => {
        commit("setCustomData", response.data);
        commit("setTotal", response.data.length);
        commit("loading", false);

        return response;
    })
    .catch(() => {
        commit("loading", false);
    });
  }
}



// modify data for file posting status
const modifyData = (arrayData) => {
  if(arrayData?.length ?? false){
    return arrayData.map(e => {
      let customData = {
        id: e.id,
        type: 'File',
        name: e.name,
        description: e.description,
        fileCount: 0,
        fileTags: null,
        file: e,
      }

      return customData;
    });
  }

  return [];
};

function saveState(key, state) {
  window.localStorage.setItem(key, JSON.stringify(state))
}

